export const products = [
  {
    slug: 'cosmic-flow',
    name: 'Cosmic Flow',
    shortName: 'Flow',
    accent: 'cyan',
    eyebrow: 'Messages into transaction drafts',
    headline: 'Orders arrive. Drafts take shape.',
    description: 'Cosmic Flow is designed to turn chats, voice notes, and order documents into structured data. Your team reviews every result before it moves into a business system.',
    capabilities: [
      'Identify customers, items, quantities, and due dates from messages.',
      'Flag incomplete details for confirmation.',
      'Prepare order drafts for team review.',
      'Connect approved drafts to inventory or sales systems through agreed integrations.',
    ],
    example: {
      source: 'Ms. Sari orders 20 cases of Arabica Coffee, deliver Friday. Same address as the previous order.',
      output: [
        ['Customer', 'Ms. Sari'],
        ['Product', 'Arabica Coffee'],
        ['Quantity', '20 cases'],
        ['Delivery date', 'Date needs confirmation'],
        ['Address', 'Confirm from customer records'],
        ['Status', 'Awaiting review'],
      ],
    },
    users: ['Sales teams', 'Order administrators', 'Distribution operations'],
    reviewSteps: ['Review identified data', 'Complete flagged information', 'Approve before it moves forward'],
    metaDescription: 'Cosmic Flow is designed to help small businesses turn order messages into reviewable transaction drafts.',
  },
  {
    slug: 'cosmic-check',
    name: 'Cosmic Check',
    shortName: 'Check',
    accent: 'amber',
    eyebrow: 'Documents into clear findings',
    headline: 'Spot the mismatch before it slips through.',
    description: 'Cosmic Check is designed to compare purchase orders, invoices, and delivery notes. Every difference appears with its source so your team can review the evidence and decide what comes next.',
    capabilities: [
      'Compare quantities, prices, and item references.',
      'Flag possible duplicate documents or invoices.',
      'Show the document lines behind every finding.',
      'Create a review list for operations teams.',
    ],
    example: {
      documents: [
        ['Purchase order', '50 units'],
        ['Delivery note', '45 units'],
        ['Invoice', '50 units'],
      ],
      finding: 'There is a 5-unit difference between the delivery note and invoice. Check whether this was a partial shipment.',
    },
    users: ['Purchasing teams', 'Finance administrators', 'Warehouse operations'],
    reviewSteps: ['Open the source documents', 'Review the mismatched lines', 'Decide the next step with your team'],
    metaDescription: 'Cosmic Check is designed to help small businesses find differences across purchase orders, delivery notes, and invoices.',
  },
  {
    slug: 'cosmic-memory',
    name: 'Cosmic Memory',
    shortName: 'Memory',
    accent: 'violet',
    eyebrow: 'Conversations into follow-through',
    headline: 'Decisions stay visible. Promises move forward.',
    description: 'Cosmic Memory is designed to capture decisions and request changes from business conversations. Every follow-up stays connected to its source message, so context is always within reach.',
    capabilities: [
      'Identify decisions, commitments, and deadlines.',
      'Show request changes in sequence.',
      'Prepare a follow-up list for confirmation.',
      'Link every note back to its source conversation.',
    ],
    example: {
      messages: ['We are ordering 100 units for Friday.', 'Can we change that to 150 units for Thursday?'],
      output: [
        ['Quantity', '100 → 150 units'],
        ['Deadline', 'Friday → Thursday'],
        ['Status', 'Not yet agreed'],
        ['Next step', 'Confirm capacity and price adjustment'],
      ],
    },
    users: ['Business owners', 'Account managers', 'Customer service teams'],
    reviewSteps: ['Read the source messages', 'Review the proposed change', 'Confirm before it becomes a commitment'],
    metaDescription: 'Cosmic Memory is designed to help small businesses capture decisions, request changes, and follow-ups from conversations.',
  },
];

export const getProductBySlug = (slug) => products.find((product) => product.slug === slug);
